/* @flow */

import React from "react";
import cn from "classnames";
import { useHistory } from "react-router";
import { useData } from "crustate/react";
import { QuoteData } from "data";
import { useTranslate } from "@awardit/react-use-translate";
import Button from "components/Button";

import CartIcon from "icons/cart.svg";

import styles from "./styles.scss";

type Props = {
  className: string,
  isOpen: boolean,
  openMiniCart: () => void,
};

const CartCounter = ({ className = "", isOpen, openMiniCart }: Props): React$Node => {
  const t = useTranslate();
  const data = useData(QuoteData);
  const history = useHistory();
  const onCheckoutCart = history.location.pathname.includes(t("URL.CHECKOUT_CART"));
  const onCheckoutOverview = history.location.pathname.includes(t("URL.CHECKOUT_OVERVIEW"));
  const cartCount = data.data ?
    data.data.items.reduce((a, { qty }) => a + qty, 0) :
    0;

  const ariaLabelInfo = () => {
    if (!onCheckoutCart && !onCheckoutOverview) {
      return isOpen ?
        t("CART.NAV_BUTTON_CLOSE", { count: cartCount }) :
        t("CART.NAV_BUTTON_OPEN", { count: cartCount });
    }

    return t("CART.NAV_BUTTON_CART", { count: cartCount });
  };

  if (cartCount > 0) {
    return (
      <Button
        type="button"
        aria-controls="cartMini"
        aria-label={ariaLabelInfo()}
        aria-expanded={isOpen ?? "false"}
        className={cn(styles.button, className)}
        onClick={() => {
          if (onCheckoutCart) {
            history.go(0);
          }
          else if (onCheckoutOverview) {
            history.push(t("URL.CHECKOUT_CART"));
          }
          else if (cartCount) {
            openMiniCart();
          }
        }}
      >
        <span className={styles.container}>
          <span className={styles.number}>
            {cartCount}
          </span>
          <CartIcon
            aria-label={t("ICONS.CART")}
            className={styles.icon}
          />
        </span>
      </Button>
    );
  }

  return (
    <div className={cn(styles.button, styles.empty, className)}>
      <span className={styles.container}>
        <CartIcon aria-label={t("ICONS.CART")} className={styles.icon} />
      </span>
    </div>
  );
};

export default CartCounter;
